<template>
  <div>
    <!-- header start -->
    <van-nav-bar :title="this.title" fixed class="navbarBg" :border="false">
      <template #left>
        <van-icon name="wap-nav" @click="toggleMenu" />
      </template>
      <template #right>
        <div class="iconbtn"><van-icon name="search" @click="goSearch" /></div>
        <div class="iconbtn">
          <van-icon name="add-o" @click="goAddMemorialHall" />
        </div>
      </template>
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <div class="ad">
      <van-swipe
        class="ad-swipe"
        :height="143"
        :autoplay="3000"
        indicator-color="white"
      >
        <van-swipe-item v-for="(item, index) in adList" :key="index">
          <router-link :to="item.url">
            <img :src="item.src"/>
          </router-link>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="menuPopupBox" v-if="ismenuPopupBox">
      <div class="content">
        <div class="item" @click="getMemorialHallType('广场', 0)">全部</div>
        <!-- <div class="item">宗亲馆</div> -->
        <div class="item" @click="getMemorialHallType('私人馆', 1)">私人馆</div>
        <div class="item" @click="getMemorialHallType('名人馆', 2)">名人馆</div>
        <!-- <div class="item" @click="getMemorialHallType('英烈馆', 5)">英烈馆</div> -->
        <div class="item" @click="getMemorialHallType('恩师馆', 6)">恩师馆</div>
        <!-- <div class="item">家族馆</div>
    		<div class="item">事件馆</div> -->
      </div>
    </div>
    <!-- header end -->
    <van-tabs
      v-model="active"
      sticky
      animated
      swipeable
      offset-top="46"
      title-active-color="#fff"
      title-inactive-color="#f2f2f2"
      background="#24a378"
      color="#fff"
      :border="false"
      @change="selectItem"
    >
      <van-tab v-for="(item, index) in tabList" :key="index" :title="item.Name">
        <explore_recommend_list
          :active="active"
          :readshowtypeid="ReadShowTypeId"
          :memorialhalltype="MemorialHallType"
          :currentind="item.Id"
          @getisPrivate="getisPrivate"
        >
        </explore_recommend_list>

        <!-- <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :offset="offset"
            :immediate-check="ischeck"
            @load="loadMore"
          >
          <div v-for="(item,index) in MemorialHallSearchApiModelList" :key="index" >
            <div v-if="item.DeceasedInformationApiModelList.length > 1">
              <router-link to="/MemorialHall" class="hall-item">
                <van-swipe class="my-swipe" :loop="false" indicator-color="orange">
                        <van-swipe-item  v-for="clientitem in item.DeceasedInformationApiModelList" :key="clientitem.id"> 
                        <div class="hall-list" @click.prevent="getisPrivate(item)">
                          <div class="bd">
                            <h2 class="sz-name">{{item.Title}}</h2>
                            <div class="sz-des">
                              <P>逝者: {{clientitem.DeceasedName}}</P>
                              <P>馆号: TT{{item.SerialNumber}}</P>
                              <P>建馆人: {{item.MemberName}}</P>
                              <P>创建时间: {{$moment(item.AddDateTime).format('YYYY-MM-DD')}}</P>
                              <P>访问量: {{item.ClickCount}}</P>
                            </div>
                          </div>
                          <div class="ft">
                            <img v-bind:src="clientitem.HeadPhoto" class="avatar">
                          </div>
                        </div>
                      </van-swipe-item>
                </van-swipe>
                <img  src="@/assets/images/double_tag_icon.png" class="double-tag" />
              </router-link>
            </div>
            <div v-else>
              <router-link to="/MemorialHall" class="hall-item">
                <div class="hall-list" @click.prevent="getisPrivate(item)">
                  <div class="bd">
                    <h2 class="sz-name">{{item.Title}}</h2>
                    <div class="sz-des">
                      <P>逝者: {{item.DeceasedInformationApiModelList[0].DeceasedName}}</P>
                      <P>馆号: TT{{item.SerialNumber}}</P>
                      <P>建馆人: {{item.MemberName}}</P>
                      <P>创建时间: {{$moment(item.AddDateTime).format('YYYY-MM-DD')}}</P>
                      <P>访问量: {{item.ClickCount}}</P>
                    </div>
                  </div>
                  <div class="ft">
                    <img v-bind:src="item.DeceasedInformationApiModelList[0].HeadPhoto" class="avatar">
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </van-list> -->
        <!-- 双人馆 -->
        <!-- <router-link to="/MemorialHall" class="hall-item">
          <van-swipe class="my-swipe" :loop="false" indicator-color="orange">
            <van-swipe-item v-for="item in 2" :key="item.id">
              <div class="hall-list" @click.prevent="isPrivate = true">
                <div class="bd">
                  <h2 class="sz-name">原广州军区空军政治委员张振先同志纪念馆</h2>
                  <div class="sz-des">
                    <P>逝者:剥落</P>
                    <P>馆号: TT1582469852</P>
                    <P>建馆人:天使</P>
                    <P>创建时间: 2015- -12-10</P>
                    <P>访问量: 184563</P>
                  </div>
                </div>
                <div class="ft">
                  <img src="https://img.yzcdn.cn/vant/cat.jpeg" class="avatar">
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
          <img src="@/assets/images/double_tag_icon.png" class="double-tag" />
        </router-link>  -->
        <!-- 单人馆 -->
        <!-- <router-link to="/MemorialHall" v-for="item in 4" :key="item.id" class="hall-item">
          <div class="hall-list" @click.prevent="isPrivate = true">
            <div class="bd">
              <h2 class="sz-name">原广州军区空军政治委员张振先同志纪念馆</h2>
              <div class="sz-des">
                <P>逝者:剥落</P>
                <P>馆号: TT1582469852</P>
                <P>建馆人:天使</P>
                <P>创建时间: 2015- -12-10</P>
                <P>访问量: 184563</P>
              </div>
            </div>
            <div class="ft">
              <img src="https://img.yzcdn.cn/vant/cat.jpeg" class="avatar">
            </div>
          </div>
        </router-link> -->
      </van-tab>
    </van-tabs>
    <!-- 隐私馆弹出 -->
    <van-popup round v-model="isPrivate">
      <div class="dialog-private">
        <h2 class="title">请输入访问密码</h2>
        <div class="control-input">
          <input
            type="text"
            placeholder=""
            ref="password"
            class="van-field__control"
          />
        </div>
        <van-button round class="mybtn" @click="btncommit">确定</van-button>
        <p class="tips">
          温馨提示:该馆属于隐私馆，只有馆主或者知道密码者方可访问，密码由馆主设置，如果您想访问，请主动联系馆主。
        </p>
        <!-- <van-button size="small" plain round class="mybtn">联系馆主</van-button> -->
        <!-- to="/PersonInfo" -->
        <van-icon name="clear" class="closeBtn" @click="isPrivate = false" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import explore_recommend_list from "@/components/explore/explore_recommend_list";
export default {
  data() {
    return {
      ismenuPopupBox: false,
      isPrivate: false,
      SerialNumber: null,
      password: null,
      active: 0,
      pageIndex: 1,
      loading: false,
      finished: false,
      offset: 100,
      ischeck: false,
      isLogin: false,
      MemorialHallSearchApiModelList: [],
      ReadShowTypeId: 1,
      MemorialHallType: 0,
      title: "广场",
      tabList: [
        { Id: 1, Name: "推荐" },
        { Id: 2, Name: "热门" },
        { Id: 3, Name: "最新" },
      ],
      adList: [
        // {
        //   src: require("@/assets/images/ad.jpg"),
        //   url: "/Zy",
        // },
        // {
        //   src: require("@/assets/images/ad01.jpg"),
        //   url: "/Create",
        // },
      ],
      scrollmap: {},
    };
  },
  components: {
    explore_recommend_list,
  },
  watch: {
    active: function(newVal, oldVal) {
      var top = document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollmap[oldVal] = top;
    },
  },
  methods: {
    init(){
      this.getAd();
    },
    getAd(){
      var that = this;
      that.$store
        .dispatch({
          type: "GetCommandAdList",
          id: 31,
        })
        .then((res) => {
          res.forEach((x) => {
            that.adList.push({
              src: x.PhotoPath,
              url: x.MobileLinkUrl
            });
          });
        });
    },
    goSearch() {
      this.$router.push("/Search");
    },
    goAddMemorialHall() {
      this.$router.push("/Create");
    },
    toggleMenu() {
      this.ismenuPopupBox = !this.ismenuPopupBox;
    },
    selectItem(index, name) {
      var that = this;
      this.loading = false;
      this.finished = false;
      this.pageIndex = 1;
      this.ReadShowTypeId = index + 1;

      this.$nextTick(() => {
        window.scrollTo(0, that.scrollmap[that.active]);
      });
    },
    // loadMore() {
    // var _this = this;
    // _this.pageIndex++;
    // _this.loading = true;
    // _this.finished = false;
    // _this.$store
    //   .dispatch({
    //     type: "GetMemorialHallSearch",
    //     pageIndex: _this.pageIndex,
    //     ReadShowType: _this.ReadShowTypeId,
    //     MemorialHallType:_this.MemorialHallType
    //   })
    //   .then(result => {
    //     _this.loading = false;
    //     var MemorialHallSearchApiModelList = result.MemorialHallSearchApiModelList;
    //     for (let i = 0; i < MemorialHallSearchApiModelList.length; i++) {
    //       _this.MemorialHallSearchApiModelList.push(
    //         MemorialHallSearchApiModelList[i]
    //       );
    //     }
    //     if (MemorialHallSearchApiModelList.length <= 0) {
    //       _this.finished = true;
    //     }
    //   });
    // },

    // getMemorialHallSearchList(ReadShowTypeId) {
    // var _this = this;
    // this.$store
    //   .dispatch({
    //     type: "GetMemorialHallSearch",
    //     ReadShowType:ReadShowTypeId,
    //     MemorialHallType:_this.MemorialHallType
    //   })
    //   .then(result => {
    //     _this.MemorialHallSearchApiModelList = result.MemorialHallSearchApiModelList;
    //     if (result.MemorialHallSearchApiModelList.length < 10) {
    //         _this.finished = true;
    //     }
    //   });
    // },
    getisPrivate(item) {
      //
      // if (!item.IsPrivacy) {
      //   this.$router.push("/MemorialHall?id=" + item.SerialNumber);
      // }
      // this.isPrivate = item.IsPrivacy;
      this.$router.push("/MemorialHall?id=" + item.SerialNumber);
      this.SerialNumber = item.SerialNumber;
      this.password = item.PrivacyPassword;
    },
    btncommit() {
      var _password = this.$refs.password.value;
      if (_password.trim() == "") {
        Toast("请输入密码再点击确定！");
        return;
      }
      if (_password != this.password) {
        Toast("纪念馆密码不正确请重新输入！");
        return;
      }
      this.isPrivate = false;
      this.$refs.password.value = "";
      this.$router.push("/MemorialHall?id=" + this.SerialNumber);
    },
    getMemorialHallType(title, typeid) {
      var that = this;
      this.title = title;
      this.MemorialHallType = typeid;
      this.ismenuPopupBox = false;
      this.scrollmap = {};
      this.$nextTick(() => {
        window.scrollTo(0, 0);
      });
      // console.log("this.MemorialHallType= " + this.MemorialHallType);
      // this.getMemorialHallSearchList(this.ReadShowTypeId);
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "Zy") {
      let memberAudio = document.querySelector("#memberAudio");
      memberAudio.pause();
    }
    next();
  },
  created() {
    // if (!this.currentUser.isLogin) {
    //   this.$router.push({ path: '/login?ReturnUrl=/MessageList' })
    //   return;
    // }
    // this.isLogin = true;
    // this.getMemorialHallSearchList(this.ReadShowTypeId);
    this.init();
  }
};
</script>

<style scoped>
.menuPopupBox {
  position: fixed;
  left: 5px;
  top: 46px;
  z-index: 100;
}
.menuPopupBox > .content {
  padding: 10px 0;
  background-color: #24a378;
  box-shadow: 0 2px 4px #999;
  border-radius: 4px;
}
.menuPopupBox > .content > .item {
  padding: 4px 18px;
  font-size: 14px;
  color: #fff;
}

.ad {
  display: flex;
  background-color: #24a378;
  height: 143px;
  .ad-swipe {
    border-radius: 10px;
    margin: 5px 15px;
  }
}
</style>
